import api from './axios';

export const usersAPI = {
  /**
   * GET /api/admin/users
   * @param {Object} params - search, gender, from, to, page, per_page
   */
  getList: (params = {}) => api.get('/admin/users', { params }),

  /**
   * GET /api/admin/users/{id}
   */
  getById: (id) => api.get(`/admin/users/${id}`),

  /**
   * GET /api/admin/users/{id}/deposits
   */
  getDeposits: (id, params = {}) => api.get(`/admin/users/${id}/deposits`, { params }),

  /**
   * GET /api/admin/users/{id}/withdrawals
   */
  getWithdrawals: (id, params = {}) => api.get(`/admin/users/${id}/withdrawals`, { params }),

  /**
   * POST /api/admin/users/{id}/profit
   * @param {number} id
   * @param {{ type: 'amount'|'percentage', value: number, note?: string }} payload
   */
  addProfit: (id, payload) => api.post(`/admin/users/${id}/profit`, payload),

  /**
   * POST /api/admin/users/{id}/reset-password
   * Returns { new_password }
   */
  resetPassword: (id, payload = {}) => api.post(`/admin/users/${id}/reset-password`, payload),

  /**
   * DELETE /api/admin/users/{id}
   */
  deleteUser: (id) => api.delete(`/admin/users/${id}`),
};
